<!--Online users-->
<kendo-dialog *ngIf="onlineUsersDialogOpened" (close)="closeOnlineUsers()" [width]="800">
    <kendo-dialog-titlebar>
        <h3>{{ 'ONLINE-USERS' | translate }} <span *ngIf="totalOnlineUsers > 0"
                class="badge badge-pill badge-secondary user-count-badge ml-2">{{totalOnlineUsers}}</span>
        </h3>
    </kendo-dialog-titlebar>
    <kendo-grid [data]=" onlineView.gridData" [loading]="onlineView.loading" [navigable]="true"
        [pageable]="totalOnlineUsers > onlineView.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
        [pageSize]="onlineView.state.take" [skip]="onlineView.state.skip" [sortable]="true"
        [sort]="onlineView.state.sort" [filterable]="enableAdvanced" [filter]="onlineView.state.filter"
        [groupable]="enableAdvanced" [group]="onlineView.groups" [selectable]="{ mode: 'multiple' }"
        [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
        (groupChange)="onlineUsersGroupChange($event)" [kendoGridSelectBy]="'id'" [selectedKeys]="selectedOnlineUsers"
        (dataStateChange)="onlineUsersDataStateChange($event)" (selectedKeysChange)="onSelectedUserKeysChange($event)"
        [max-height]="500" class="mt-2">
        <kendo-grid-messages noRecords="{{ 'NO-USERS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="6" class="text-center"
            headerClass="text-center">
        </kendo-grid-checkbox-column>
        <kendo-grid-column field="name" [width]="35" title="{{ 'NAME' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <img *ngIf="photoMap.has(photoMapKey(dataItem)) && photoMap.get(photoMapKey(dataItem)).length > 2"
                    [src]="photoMap.get(photoMapKey(dataItem))" alt="{{'PHOTO' | translate}}" class="avatar-custom">
                <kendo-avatar *ngIf="photoMap.has(photoMapKey(dataItem)) && photoMap.get(photoMapKey(dataItem)).length <= 2"
                    class="avatar-custom" shape="circle" initials="{{photoMap.get(photoMapKey(dataItem))|uppercase}}">
                </kendo-avatar>
                <span class="ml-2">
                    {{ dataItem.name }}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="organizationName" [width]="40" title="{{ 'ORGANIZATION' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column field="roleName" title="{{ 'USER-ROLE' | translate }}" [width]="25">
            <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="onlineView.filter" [data]="userRoles" filterField="roleName"
                    selectDefaultText="{{ 'SELECT-ROLE' | translate }}" textField="text" valueField="text">
                </app-dropdown-filter>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
    <kendo-dialog-actions>
        <button kendoButton (click)="closeOnlineUsers()">{{ 'CLOSE' | translate }}</button>
        <button class="float-right" kendoButton [primary]="true" type="button"
            [disabled]="selectedOnlineUsers.length === 0" (click)="sendNotifications()">
            {{'SEND-NOTIFICATIONS' | translate }}<span
                *ngIf="getSelectedUserCount() > 0">({{getSelectedUserCount()}})</span>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Notification Message to Send-->
<kendo-dialog title="{{ 'SEND-NOTIFICATION' | translate }}" *ngIf="notificationDialogOpened"
    (close)="closeNotificationDialog()" [width]="700">
    <form [formGroup]="notificationForm" class="k-form">
        <div class="row">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'FROM' | translate}} *
                    </span>
                    <input id="fromName" kendoTextBox formControlName="fromName" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="fromName.hasError('required') && fromName.touched">
                        {{'REQUIRED-FROM' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-6">
                <label for="type" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'TYPE' | translate}} *
                    </span>
                    <kendo-combobox formControlName="type" [data]="notificationTypes" [textField]="'text'"
                        [valueField]="'value'" [valuePrimitive]="true">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="type.hasError('required') && type.touched">
                        {{'REQUIRED-FIELD-TYPE' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NOTIFICATION-TEXT' | translate}} *
                    </span>
                    <textarea #notificationControl kendoTextArea class="w-100 k-textarea" rows="4"
                        formControlName="notification">
                    </textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="notification.hasError('required') && notification.touched">
                        {{'REQUIRED-NOTIFICATION-TEXT' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row" style="min-height:60px">
            <div class="col-5">
                <div class="k-form-field mt-3">
                    <input type="checkbox" id="forceLogout" formControlName="forceLogout" kendoCheckBox />
                    <label class="k-checkbox-label k-text-uppercase dark" for="forceLogout">
                        {{ 'FORCE-LOGOUT' | translate }}
                    </label>
                </div>
            </div>
            <div class="col-7" *ngIf="forceLogout.value" style="text-align:end">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'LOGOUT-DELAY' | translate}}
                    </span>
                    <kendo-numerictextbox [format]="'n0'" formControlName="logoutDelay" [min]="0" [max]="3600"
                        class="w-25">
                    </kendo-numerictextbox>
                </label>
            </div>
        </div>
    </form>
    <kendo-dialog-actions>
        <button kendoButton (click)="closeNotificationDialog()">{{ 'CANCEL' | translate }}</button>
        <button class="float-right" kendoButton [primary]="true" type="button"
            [disabled]="!notificationForm.valid || !notificationForm.dirty" (click)="send()">
            {{'SEND-NOTIFICATIONS' | translate }}<span
                *ngIf="getSelectedUserCount() > 0">({{getSelectedUserCount()}})</span>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>